import { SettingsApplicationsOutlined } from '@material-ui/icons';
import firebase from '../../../../../Firebase/Firebase'
import React, { useState, useEffect } from 'react';
import UploadImage from '../../../../../Assets/image/UploadImage.png';
import './ReviewContainer.css';
import loading from '../../../../../Assets/image/loader.gif'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withParams } from '../../../../containers/WithParams';
import addPrototypeActions from '../../../../actions/addPrototype';
import PropTypes from 'prop-types';

const ReviewContainer = (props) => {
    const { linkToFile, questionStatement, getPrototypeResponse, productId, next } = props;
    const reviewId = 1;
    const initState = {
        reviewId: reviewId,
        answer: "",
        linkToFile: ""
    };

    const [addItem, setAddItem] = useState(initState);
    // const [previewItems, setPreviewItems] = useState([]);
    const [link, setLink] = useState('');
    const [files, setFiles] = useState(null);
    const [checkUpload, setCheckUpload] = useState(false);


    const handleChange = (e) => {
        setFiles(e.target.files);
    };

    const handleAnsChange = (e) => {
        e.preventDefault();
        setAddItem({ ...addItem, ['answer']: e.target.value })
    }

    const handleUpload = () => {
        setCheckUpload(true);
        const bucketName = "Uranch/images";
        const file = files[0];
        const storageRef = firebase.storage().ref(`${bucketName}/${file.name}`);
        const uploadTask = storageRef.put(file).on(firebase.storage.TaskEvent.STATE_CHANGED, () => {
            const temp = storageRef.getDownloadURL().then((url) => {
                setLink(url);
                setCheckUpload(false);
            });
        });
    };

    const handleSave = (e) => {
        handleUpload()
        // if (checkUpload) {
            getPrototypeResponse({ ...addItem }, reviewId, productId, next)
        // }

    }
    useEffect(() => {
        setAddItem({ ...addItem, ['linkToFile']: link })
    }, [link])


    return (
        <div className="outer-review-container">
            <div className="reviewImgwrapper">
                <div className="review-img-container">
                    <img src={linkToFile} />
                </div>
                {/* <p>(click to expand image)</p> */}
            </div>
            <div className="review-decription-container">
                <div className="question-about">
                    <p><b>{questionStatement}?</b></p>
                    <div className="commmon-outer-divs" id="review-answer-div">
                        <textarea name="answer" placeholder=" Your answer here..."
                            type="text" value={addItem['answer']}
                            onChange={handleAnsChange}
                        ></textarea>
                    </div>
                </div>
                <div className="comments-container">
                    <p>Upload your comments:</p>
                    <div className="commmon-outer-divs" id="choose-file-div">
                        <label for="file-upload" class="choose-file-btn">
                            Choose File
                        </label>
                        <input id="file-upload" type="file" onChange={handleChange} />
                        <small>(.doc, .jpeg, .txt file)</small>
                        {checkUpload ? <img src={loading} height="37px" width="37px"></img> : null}
                    </div>
                </div>
                <button className="save-review-btn" onClick={handleSave}>Save</button>
            </div>
        </div>
    )
}

ReviewContainer.propTypes = {
    productList: PropTypes.object
}

ReviewContainer.defaultProps = {
    productList: {}
}


const mapStateToProps = state => ({
});
const mapDispatchToProps = (dispatch) => ({
    getPrototypeResponse: ({ ...addItem }, reviewId, productId, next) => {
        dispatch(addPrototypeActions.getPrototypeResponse({ ...addItem }, reviewId, productId, next));
    },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withParams(ReviewContainer)));
